import { Button, Card, EmptyState, Text } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import { templateToInitialState, usePriceListTemplates } from '../hooks/use-price-list-templates';

export function PriceListEmptyState() {
  const { navigationHandler } = useHandlers();
  const templates = usePriceListTemplates();

  return (
    <Card>
      <EmptyState
        title={t('price_lists.empty_state.title')}
        subtitle={t('price_lists.empty_state.description')}
        imageType="priceList"
      >
        <div className="flex w-full flex-col items-center gap-6">
          <Button onClick={() => navigationHandler.navigate('/pricing/lists/create')}>
            {t('price_lists.empty_state.create')}
          </Button>

          {templates.length > 0 && (
            <div className="flex flex-col items-center gap-4 text-center">
              <Text variant="secondary">{t('price_lists.empty_state.templates.description')}</Text>

              <ul className="flex items-center gap-2">
                {templates.map((list) => {
                  const initial = templateToInitialState(list);
                  return (
                    <li className="flex items-center" key={initial.handle}>
                      <Button
                        variant="secondary"
                        onClick={() =>
                          navigationHandler.navigate('/pricing/lists/create', {
                            query: { template: initial.handle },
                          })
                        }
                      >
                        {initial.name}
                      </Button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </EmptyState>
    </Card>
  );
}
